import React from "react";

export const ResultsIcon = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M25.0497 4.19922H14.9508C13.1686 4.2012 11.7244 5.61915 11.7227 7.36896V30.8295C11.7244 32.5793 13.1686 33.9973 14.9508 33.999H25.0497C26.8319 33.9973 28.2761 32.5793 28.2781 30.8295V7.36896C28.2761 5.61915 26.8319 4.2012 25.0497 4.19922ZM26.8983 30.8295C26.8973 31.8315 26.0702 32.6436 25.0497 32.6446H14.9508C13.9303 32.6436 13.1032 31.8315 13.1022 30.8295V7.36896C13.1032 6.3667 13.9303 5.55467 14.9508 5.55368H25.0497C26.0702 5.55467 26.8973 6.3667 26.8983 7.36896V30.8295Z"
      fill="currentColor"
    />
    <path
      d="M22.067 6.9082H17.9282C17.5472 6.9082 17.2383 7.21129 17.2383 7.58531C17.2383 7.95933 17.5472 8.26266 17.9282 8.26266H22.067C22.448 8.26266 22.7567 7.95933 22.7567 7.58531C22.7567 7.21129 22.448 6.9082 22.067 6.9082Z"
      fill="currentColor"
    />
    <path
      d="M21.3804 29.9345C21.3804 30.6828 20.7628 31.2892 20.0009 31.2892C19.2387 31.2892 18.6211 30.6828 18.6211 29.9345C18.6211 29.1865 19.2387 28.5801 20.0009 28.5801C20.7628 28.5801 21.3804 29.1865 21.3804 29.9345Z"
      fill="currentColor"
    />
  </svg>
);
